import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth, dashboardPath, formatApiErrorDetail } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      navigate(dashboardPath(user.role));
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-white grid-noise">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="bg-white border border-foreground p-8">
          <span className="label-caps text-primary">Account access</span>
          <h1 className="font-display font-bold text-3xl tracking-tight mt-2 mb-6">Log in</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="label-caps">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                     className="rounded-none mt-2 h-11" data-testid="login-email" placeholder="you@company.com" />
            </div>
            <div>
              <Label className="label-caps">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                     className="rounded-none mt-2 h-11" data-testid="login-password" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-none bg-primary hover:bg-primary/90 h-11" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>

          <div className="flex items-center gap-3 my-5">
            <div className="h-px bg-border flex-1" />
            <span className="text-xs text-muted-foreground uppercase tracking-wider">or</span>
            <div className="h-px bg-border flex-1" />
          </div>

          <Button onClick={googleLogin} variant="outline" className="w-full rounded-none h-11 border-foreground" data-testid="login-google">
            Continue with Google
          </Button>

          <p className="text-sm text-muted-foreground mt-6 text-center">
            No account? <Link to="/register" className="text-primary font-medium" data-testid="login-to-register">Register here</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
